import axios from 'axios';
import config from './config';
import qs from 'qs';
import router from './../router';
// 使用vuex做全局loading时使用
// import store from '@/store'
export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseURL,
      headers: {},
      transformResponse: [function (data) {
      }]
    })

  //  request 拦截器
    // instance.interceptors.request.use(

    //   config => { 
      
    //      let token = Cookies.get('primaryKey')
       
    //     if (token) {
          
    //     } else {
    //       // 重定向到登录页面
    //       router.push('/Error')
    //       return
    //     }
   
    //     return config
    //   },
      
    // )

    // response 拦截器
    instance.interceptors.response.use(
      response => { 
        let data;
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data == undefined) {
          data = JSON.parse(response.request.responseText)
        } else {
          data = response.data
        }
         if(data.error_message){
           router.push({name:'Message',path:'/Message',params:{message:data.error_message}});
           return
         
        }
    
        return data
      },
      error => {
         
        if (error && error.response) {
          switch (error.response.status) {
            case 400:
              error.message = '请求错误，请稍后重试！'
              break

            case 401:
              error.message = '未授权，请登录，请稍后重试！'
              break

            case 403:
              error.message = '拒绝访问，请稍后重试！'
              break

            case 404:
              error.message = `网络异常，请稍后重试！`
              break

            case 408:
              error.message = '请求超时，请稍后重试！'
              break

            case 500:
              error.message = '服务器内部错误，请稍后重试！'
              break

            case 501:
              error.message = '服务未实现，请稍后重试！'
              break

            case 502:
              error.message = '网关错误，请稍后重试！'
              break

            case 503:
              error.message = '服务不可用，请稍后重试！'
              break

            case 504:
              error.message = '网关超时，请稍后重试！'
              break

            case 505:
              error.message = 'HTTP版本不受支持，请稍后重试！'
              break

            default:
          }
        }
        return Promise.reject(error) // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options).then(res => {
      resolve(res)
      return res
    })
    .catch(error => {
      reject(error)
    return   error
    })
  })
}


// WEBPACK FOOTER //
// ./src/http/api.js